export class Banco {
  id:string;
  codigo:string;
  nome:string;
  codigoNome:string;

  constructor(
      id?:string, codigo?:string, nome?:string, codigoNome?:string)
  {
      this.id = id;
      this.codigo = codigo;
      this.nome = nome;
      this.codigoNome = codigoNome;
  }
}